export const GeoQuitModal = (
  { isOpen, onClose, onQuit }: {
    isOpen: boolean;
    onClose: () => void;
    onQuit: () => void;
  },
) => {
  if (!isOpen) return null;

  return (
    <dialog open class="modal modal-open">
      <div class="modal-box">
        <h3 class="font-bold text-lg">Quit Game?</h3>
        <p class="py-4">
          Are you sure you want to leave this game? You will be removed from the
          room.
        </p>
        <div class="modal-action">
          <button type="button" class="btn btn-ghost" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-error"
            onClick={onQuit}
          >
            Quit
          </button>
        </div>
      </div>
    </dialog>
  );
};
